import ky from 'ky'
import Auth2 from 'plugin/src/shared/Auth2'
import { API_BASE_URL } from '@mote/config/constants'
import { TRACK_EVENT_NAMES, __DEV__ } from '@mote/helpers/constants'
import { getExtensionVersion, isInExtension } from '@mote/helpers/extension'
import { trackRaw } from './useTrackMutation'

const inExtension = isInExtension()

const apiClient = ky.extend({
  prefixUrl: API_BASE_URL
})

export function postErrorEvent({
  title,
  key,
  text,
  tags,
  userVisible,
  asset_id
}) {
  if (__DEV__) return

  if (!tags) {
    tags = []
  }
  if (!asset_id && inExtension) {
    asset_id = 'unknown'
  }

  if (inExtension) {
    return extension(userVisible, title, key, text, tags, asset_id)
  }

  return web(title, key, text, tags)
}

// helpers
function web(title, key, text, tags) {
  const defaultTags = ['web:1', 'user_visible_error:1', key + ':1']
  const outputTags = defaultTags.concat(tags)
  text += '\n\nCurrent URL: ' + window.location.href
  const payload = { title, key, text, tags: outputTags }

  trackRaw({
    variables: {
      event: `Error Seen on Web: ${title}`,
      error_key: key,
      error_text: text
    }
  })

  return postError(payload)
}

function extension(userVisible, title, key, text, tags, asset_id) {
  tags.push('event_version:2')
  tags.push('user_visible:' + (userVisible ? '1' : '0'))
  tags.push('extension:1')
  text = _generatePreamble() + text
  const payload = { title, key, text, tags }

  if (userVisible) {
    trackRaw({
      variables: {
        event: TRACK_EVENT_NAMES.error.occurred,
        title: title,
        key: key,
        text: text,
        event_version: 2,
        direct_from_client: true,
        content_asset_id: asset_id
      }
    })
  }
}

function _generatePreamble() {
  let preamble = ''
  if (Auth2.isLoggedIn()) {
    preamble = 'Logged in as: ' + Auth2.getUserId()
  } else {
    preamble = 'Not logged in'
  }
  preamble += ' (on version ' + getExtensionVersion() + ')\n\n'
  return preamble
}

function postError(payload) {
  apiClient
    .post('d/error', { json: payload })
    .catch(e => console.error('Could not send error event: ', payload, e))
}
